import React from 'react';
import Features from '../../../const/Features';
import FeatureService from '../../../services/feature/FeatureService';
import { isFromCallcenter } from '../../../services/queryService/QueryService';
import * as RefreshTokenCallcenterUC from '../../../usecases/refreshToken/RefreshTokenCallcenterUC';

class RefreshTokenCallcenterProvider extends React.Component {
  constructor() {
    super();

    FeatureService.isFeatureEnabled(Features.CALLCENTER_MODE).then(isEnabled => {
      if (isEnabled && isFromCallcenter()) {
        RefreshTokenCallcenterUC.execute();
      }
    });
  }

  render() {
    return <div />;
  }
}

export default RefreshTokenCallcenterProvider;



// WEBPACK FOOTER //
// ./src/components/providers/refreshTokenCallcenter/RefreshTokenCallcenterProvider.jsx